import React from "react";
import {
  makeRequestAuth,
  setGlobalCookie,
  getCookieToken,
} from "../../utils/globals";

import { withRouter } from "react-router-dom";
import { app_path } from "config";
import { CircularLoader } from "@plum-xoxo/admin-dsm";

//callback for add fund
class PaymentCallback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.props.history.location.search) {
        this.setState(
          {
            data: atob(this.props.history.location.search.split("?")[1]),
          },
          () => this.paymentUpdate()
        );
      }
    }, 2000);
  }

  paymentUpdate = () => {
    let data = JSON.parse(this.state.data);
    let order_id = data["txnid"]
      ? data["txnid"].split("_")[3]
        ? data["txnid"].split("_")[3]
        : data["txnid"]
      : "";
    let order_id_encoded = btoa(order_id);
    let callbackPath = data["udf1"];
    let status = data["status"];
    let origin = "plum";
    const rechargeFailReason = data["error_Message"];
    const amount = sessionStorage.getItem("rechargeAmount") || 0;
    let respData = {
      mihpayid: data["mihpayid"],
      mode: data["mode"],
      status: data["status"],
      unmappedstatus: data["unmappedstatus"],
      key: data["key"],
      txnid: data["txnid"],
      amount: data["amount"],
      cardCategory: data["cardCategory"],
      discount: data["discount"],
      net_amount_debit: data["net_amount_debit"],
      addedon: data["addedon"],
      productinfo: data["productinfo"],
      firstname: data["firstname"],
      lastname: data["lastname"],
      address1: data["address1"],
      address2: data["address2"],
      city: data["city"],
      state: data["state"],
      country: data["country"],
      zipcode: data["zipcode"],
      email: data["email"],
      phone: data["phone"],
      udf1: data["udf1"],
      udf2: data["udf2"],
      udf3: data["udf3"],
      udf4: data["udf4"],
      udf5: data["udf5"],
      udf6: data["udf6"],
      udf7: data["udf7"],
      udf8: data["udf8"],
      udf9: data["udf9"],
      udf10: data["udf10"],
      hash: data["hash"],
      field1: data["field1"],
      field2: data["field2"],
      field3: data["field3"],
      field4: data["field4"],
      field5: data["field5"],
      field6: data["field6"],
      field7: data["field7"],
      field8: data["field8"],
      field9: data["field9"],
      payment_source: data["payment_source"],
      PG_TYPE: data["PG_TYPE"],
      bank_ref_num: data["bank_ref_num"],
      bankcode: data["bankcode"],
      error: data["error"],
      error_Message: data["error_Message"],
      name_on_card: data["name_on_card"],
      cardnum: data["cardnum"],
      cardhash: data["cardhash"],
      issuing_bank: data["issuing_bank"],
      additionalCharges: data["additionalCharges"],
    };

    let send_data = {
      order_id: order_id,
      payu_response: respData,
    };

    if (status == "success") {
      if (
        !getCookieToken("ADMIN_TRANSECTION_ID") ||
        getCookieToken("ADMIN_TRANSECTION_ID") !== order_id
      ) {
        this.orderUpdate(
          send_data,
          order_id_encoded,
          callbackPath,
          origin,
          amount,
          rechargeFailReason
        );
      }
    } else if (status == "failure") {
      this.orderUpdate(
        send_data,
        order_id_encoded,
        callbackPath,
        origin,
        amount,
        rechargeFailReason
      );
      this.props.history.push({
        pathname: `/${app_path}/payment-status/fail/` + order_id_encoded,
        state: JSON.stringify({
          callbackPath: callbackPath,
          order_id,
          origin: origin,
          status: "fail",
          amount: parseInt(amount),
          rechargeFailReason: rechargeFailReason,
        }),
      });
    } else if (status == "cancel") {
      this.orderUpdate(
        send_data,
        order_id_encoded,
        callbackPath,
        origin,
        amount,
        rechargeFailReason
      );
      this.props.history.push({
        pathname: `/${app_path}/payment-status/cancel/` + order_id_encoded,
        state: JSON.stringify({
          callbackPath: callbackPath,
          order_id: order_id,
          origin: origin,
          status: "cancel",
          amount: parseInt(amount),
        }),
      });
    } else {
      this.orderUpdate(
        send_data,
        order_id_encoded,
        callbackPath,
        origin,
        amount,
        rechargeFailReason
      );
      this.props.history.push({
        pathname: `/${app_path}/payment-status/fail/` + order_id_encoded,
        state: JSON.stringify({
          callbackPath: callbackPath,
          order_id: order_id,
          origin: origin,
          status: "fail",
          amount: parseInt(amount),
          rechargeFailReason: rechargeFailReason,
        }),
      });
    }
  };

  orderUpdate = (
    send_data,
    order_id_encoded,
    callbackPath,
    origin,
    amount,
    rechargeFailReason
  ) => {
    const request = {
      query: "storesAdmin.mutation.paymentUpdate",
      tag: "storeAdmin",
      variables: {
        add_data: send_data,
      },
    };

    makeRequestAuth(
      request,
      function (response) {
        if (
          response !== undefined &&
          response.data.paymentUpdate &&
          response.data.paymentUpdate.error == false
        ) {
          setGlobalCookie("ADMIN_TRANSECTION_ID", send_data.order_id);

          this.props.history.push({
            pathname: `/${app_path}/payment-status/success/` + order_id_encoded,
            state: JSON.stringify({
              callbackPath: callbackPath,
              order_id: send_data.order_id,
              origin: origin,
              status: "success",
              amount: parseInt(amount),
            }),
          });
        } else {
          this.props.history.push({
            pathname: `/${app_path}/payment-status/fail/` + order_id_encoded,
            state: JSON.stringify({
              callbackPath: callbackPath,
              order_id: send_data.order_id,
              origin: origin,
              status: "fail",
              amount: parseInt(amount),
              rechargeFailReason: rechargeFailReason,
            }),
          });
        }
      }.bind(this)
    );
  };

  render() {
    return (
      <CircularLoader
        size="lg"
        vertical
        center
        content="Please do not refresh the page and wait while we are processing your
            payment..."
      />
    );
  }
}

export default withRouter(PaymentCallback);
